import React from "react";
import {Modal} from "antd";
import {useTranslation} from "react-i18next";

const PreferenceNotificationModal = ({
    visibility,
    onCancel,
    resolvePreferences,
    openPreferencesCount
}) => {
    const {t} = useTranslation(["shiftSuggestion"]);
    const onOk = async () => {
        resolvePreferences();
    };

    return (
        <Modal
            centered
            title={t("sendNotificationModalTitle", {ns: "shiftSuggestion"})}
            visible={visibility}
            onOk={onOk}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
            onCancel={onCancel}
        >
            <div>
                <p>
                    {t("couriersWillBeNotified", {
                        ns: "shiftSuggestion",
                        count: openPreferencesCount
                    })}
                </p>
            </div>
        </Modal>
    );
};

export default PreferenceNotificationModal;
